import { render } from "./Dashboard-tap.vue?vue&type=template&id=350b5bb5"
import script from "./Dashboard-tap.vue?vue&type=script&lang=js"
export * from "./Dashboard-tap.vue?vue&type=script&lang=js"

import "./Dashboard-tap.vue?vue&type=style&index=0&id=350b5bb5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__